import React from 'react';

export function Malaysia(props) {
  return (
    <svg width="513" height="342" viewBox="0 0 513 342" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="513" height="342" fill="white"/>
      {[0,1,2,3,4,5,6].map(i => (
        <rect key={i} x="0" y={i * 48} width="513" height="24" fill="#CC0001"/>
      ))}
      <rect x="0" y="0" width="220" height="180" fill="#006FAD"/>
      <path d="M80,90 C80,60 105,38 130,45 C115,55 108,70 110,90 C108,110 115,125 130,135 C105,142 80,120 80,90Z" fill="#FFD100"/>
      <polygon points="145,60 150,75 165,75 153,84 158,99 145,90 132,99 137,84 125,75 140,75" fill="#FFD100"/>
    </svg>
  );
}
